'use client';
import { useQuery } from '@tanstack/react-query';

import { mentionsApi } from '@/services/api/mentions.api';
import { MentionsQueryParams } from '@/types/mention.types';

export const MENTIONS_QUERY_KEYS = {
  all: ['mentions'] as const,
  list: (params: MentionsQueryParams) => [...MENTIONS_QUERY_KEYS.all, 'list', params] as const,
};

export const useMentionsQuery = (params?: MentionsQueryParams) => {
  const defaultParams: MentionsQueryParams = {
    limit: 20,
    order: 'createdAt',
    ascending: true,
    closed: false,
    active: true,
    tag_id: 100343,
  };

  const finalParams = { ...defaultParams, ...params };

  return useQuery({
    queryKey: MENTIONS_QUERY_KEYS.list(finalParams),
    queryFn: () => mentionsApi.getMentions(finalParams),
    select: (data) => data.data || [],
    staleTime: 60000,
    gcTime: 5 * 60 * 1000,
  });
};
